import { z } from "zod";

export const BarSchema = z
  .object({
    barState: z.string().min(1, "Required"),
    barNumber: z.string().min(1, "Required")
  });

export type BarInput = z.infer<typeof BarSchema>;
